"use strict";

class CustomerToolCompareController {

    constructor($scope, $rootScope, $timeout, Fullscreen, SSHttpService, SSUtilService, SSAppService, $sce) {
        const self = this;

        self.$scope = $scope;
        self.$rootScope = $rootScope;
        self.$timeout = $timeout;
        self.sce = $sce;
        self.Fullscreen = Fullscreen;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;

        self.unitAssetFloorPlanImgConst = SHOWSUITE.unitAssetFloorPlanImgConst;
        self.propertyAssetHeroImgConst = SHOWSUITE.propertyAssetHeroImgConst;

        self.propertiesToCompare = [];
        self.propertyFacilitiesTop = [];
        self.propertyFacilitiesHidden = [];
        self.propertyPanelHidden = [];
        self.facilityIcon = [];

        self.propertyId = SHOWSUITE.propertyId;
        self.unitType = SHOWSUITE.unitType;
        self.unitId = SHOWSUITE.unitId;

        self.PROPERTY_ASSET_TYPE_HERO_IMAGE = SHOWSUITE.PROPERTY_ASSET_TYPE_HERO_IMAGE;
        self.FLOORPLAN_ASSET_TYPE_FLOOR_PLAN_IMAGE = SHOWSUITE.FLOORPLAN_ASSET_TYPE_FLOOR_PLAN_IMAGE;

        self.projectsViewLimit = self.SSUtilService.isMobile() ? 2 : 4;

        self.init();
    }

    init() {
        const self = this;

        self.getProperties();

    }

    getProperties() {
        const self = this;

        let url = 'properties';
        let params = {
            offset: 0,
            limit: 500
        };

        self.properties = {};

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                return;
            }

            let facilities = [];

            _.forEach(response.data.properties, function (property) {
                self.properties[property.id] = property;

                self.propertyFacilitiesTop[property.id] = {};
                self.propertyFacilitiesHidden[property.id] = {};

                facilities = _.uniq(property.facilities.split("\n"), 'name');
                // Fetch first 10 records
                self.propertyFacilitiesTop[property.id] = facilities.slice(0, 10);
                // Fetch records from 10 to onward
                self.propertyFacilitiesHidden[property.id] = facilities.slice(10, _.size(facilities));
                self.propertyPanelHidden[property.id] = false;

                self.getFacilityIcon(facilities, property.id);

                if (property.id == self.propertyId) {
                    self.propertiesToCompare.push({
                        property: property,
                        unitType: self.unitType
                    });
                }
            });

            // if (!jQuery.isEmptyObject(self.properties) && jQuery.isEmptyObject(self.propertiesToCompare)) {
            //     self.propertiesToCompare.push({
            //         property: self.properties[Object.keys(self.properties)[0]]
            //     });
            // }

            // Update 'project-select'
            self.$timeout(function() { $("select.project-select").niceSelect('update'); });

            // self.changeProject(0);
        });
    }

    renderHtml(content) {
        const self = this;

        return self.sce.trustAsHtml(content);
    }

    changeProject(projectIndex) {
        const self = this;

        let propertyToCompare = self.propertiesToCompare[projectIndex];
        let property = propertyToCompare.property;

        if (!jQuery.isEmptyObject(property.unitsMap)){
            self.updateSelector('unitType_' + projectIndex);
            self.updateSelector('projectUnit_' + projectIndex);
            return;
        }

        property.unitsMap = {};
        property.unitTypes = {};

        let url = 'properties/' + property.id + '/compare';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                return;
            }

            _.forEach(response.data.property_units, function (unit) {
                if (!_.has(property.unitsMap, unit.type)){
                    
                    property.unitTypes[unit.type] = self.SSAppService.getUnitTypeName(unit.type);
                    property.unitsMap[unit.type] = {};
                }

                property.unitsMap[unit.type][unit.id] = unit;

                if (projectIndex == 0 && !propertyToCompare.unit && unit.id == self.unitId) {
                    propertyToCompare.unit = unit;
                }
            });

            // Update 'UnitType' dropdown
            self.updateSelector('unitType_' + projectIndex);

        });

    }

    updateUnitNo(selectorId) {
        const self = this;

        self.updateSelector(selectorId);
    }

    updateSelector(selectorId) {
        const self = this;

        self.$timeout(function() { $("select.project-select#" + selectorId).niceSelect('update'); });
    }

    addProjectToCompare() {
        const self = this;
        
        if (self.propertiesToCompare.length < self.projectsViewLimit) {
            self.propertiesToCompare.push({});
        }

        let selectorId = 'project_' + (self.propertiesToCompare.length - 1).toString();
        // Update 'Project' dropdown
        self.updateSelector(selectorId);

    }

    removeProject(index) {
        const self = this;

        self.propertiesToCompare.splice(index, 1);
    }

    getPropertyThumb(property) {
        const self = this;

        let file_uri = null;

        if (property && property.property_assets) {
            jQuery.each(property.property_assets, function(i, e) {
                if (e.type == self.PROPERTY_ASSET_TYPE_HERO_IMAGE) {
                    file_uri = self.SSAppService.getAssetUrl(e.file_uri);
                    return false;
                }
            });
        }

        return file_uri;
    }

    getUnitThumb(unit) {
        const self = this;
        
        let file_uri = null;

        if (unit && unit.unit_assets) {
            jQuery.each(unit.unit_assets, function(i, e) {
                if (e.type == self.FLOORPLAN_ASSET_TYPE_FLOOR_PLAN_IMAGE) {
                    file_uri = self.SSAppService.getAssetUrl(e.file_uri);
                    return false;
                }
            });
        }

        return file_uri;
    }

    // Fullscreen
    toggleFullscreen($event) {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.Fullscreen.cancel();
        } else {
            if (!$event) return;

            if (typeof $event == "string") {
                self.Fullscreen.enable(document.getElementById($event));
            } else if ($event.currentTarget.tagName === "BUTTON") {
                self.Fullscreen.enable($event.currentTarget.parentNode);
            } else {
                self.Fullscreen.enable($event.currentTarget);
            }
        }
    }
    // Fullscreen

    isProjectSelected() {
        const self = this;

        let isSelected = false;

        jQuery.each(self.propertiesToCompare, function(i, e) {
            if (e.property) {
                isSelected = true;
                return false;
            }
        });

        return isSelected;
    }

    isUnitSelected() {
        const self = this;

        let isSelected = false;

        jQuery.each(self.propertiesToCompare, function (i, e) {
            if (e.property && e.unit) {
                isSelected = true;
                return false;
            }
        });

        return isSelected;
    }

    getFacilityIcon(facilities, propertyId){
        const self = this;

        self.facilityIcon[propertyId] = [];

        _.forEach(facilities, function(facility){

            if(_.includes(facility.toLowerCase(), "entrance")){
                self.facilityIcon[propertyId].push("icon-entrance");
            }
            else if(_.includes(facility.toLowerCase(), "residential")){
                self.facilityIcon[propertyId].push("icon-residentlounge");
            }
            else if(_.includes(facility.toLowerCase(), "arrival lift")){
                self.facilityIcon[propertyId].push("icon-arrivallounge");
            }
            else if(_.includes(facility.toLowerCase(), "lounge")){
                self.facilityIcon[propertyId].push("icon-lobby-lounge");
            }
            else if(_.includes(facility.toLowerCase(), "lift lobby")){
                self.facilityIcon[propertyId].push("icon-lobby");
            }
            else if(_.includes(facility.toLowerCase(), "bicycle bay")){
                self.facilityIcon[propertyId].push("icon-bicycle-bay");
            }
            else if(_.includes(facility.toLowerCase(), "gates")){
                self.facilityIcon[propertyId].push("icon-entrance");
            }
            else if(_.includes(facility.toLowerCase(), "drop-off")){
                self.facilityIcon[propertyId].push("icon-dropoffarea");
            }
            else if(_.includes(facility.toLowerCase(), "garden")){
                self.facilityIcon[propertyId].push("icon-garden-02");
            }
            else if(_.includes(facility.toLowerCase(), "fern garden")){
                self.facilityIcon[propertyId].push("icon-fern-garden");
            }
            else if(_.includes(facility.toLowerCase(), "pool")){
                self.facilityIcon[propertyId].push("icon-entrance");
            }
            else if(_.includes(facility.toLowerCase(), "reflexology")){
                self.facilityIcon[propertyId].push("icon-residentlounge");
            }
            else if(_.includes(facility.toLowerCase(), "bbq")){
                self.facilityIcon[propertyId].push("icon-residentlounge");
            }
            else if(_.includes(facility.toLowerCase(), "Studio")){
                self.facilityIcon[propertyId].push("icon-dropoffarea");
            }
            else if(_.includes(facility.toLowerCase(), "gym")){
                self.facilityIcon[propertyId].push("icon-lobby");
            }
            else if(_.includes(facility.toLowerCase(), "bicycle bay")){
                self.facilityIcon[propertyId].push("icon-bicycle-bay");
            }
            else if(_.includes(facility.toLowerCase(), "lawn")){
                self.facilityIcon[propertyId].push("icon-arrivallounge");
            }
            else if(_.includes(facility.toLowerCase(), "jogging")){
                self.facilityIcon[propertyId].push("icon-garden-02");
            }
            else{
                 self.facilityIcon[propertyId].push("icon-fern-garden");
            }
        });

    }

}

CustomerToolCompareController.$inject = ['$scope', '$rootScope', '$timeout', 'Fullscreen', 'SSHttpService', 'SSUtilService', 'SSAppService', '$sce'];
app.controller('CustomerToolCompareController', CustomerToolCompareController);
